export default __webpack_public_path__ + "static/media/illust_autoreply.0bf9a94b.svg";